<div class="show-button">
  @if (isShowMore()) {
    <button
      class="show-more-button"
      data-cy="show-more-button"
      siriusButton
      [buttonText]="translations()!.button.showMore"
      [buttonType]="'linkstyle'"
      iconName="caret_down"
    (click)="toggleEvent()"></button>
  }
  @if (!isShowMore()) {
    <button
      class="show-less-button"
      data-cy="show-less-button"
      siriusButton
      [buttonText]="translations()!.button.showLess"
      [buttonType]="'linkstyle'"
      iconName="caret_up"
    (click)="toggleEvent()"></button>
  }
</div>
